/**
 * Auth transport contract shared by backend enforcement and clients.
 *
 * Two principal sources resolve to the same {@link Principal} (see principal.ts):
 *   - UI members: Microsoft Entra ID bearer JWT in the `Authorization` header.
 *   - API users: an API key in the `X-Api-Key` header.
 */
/** Header carrying an API user's key. Lower-cased per Node's header normalization. */
export const API_KEY_HEADER = 'x-api-key';
/** Header carrying an Entra member bearer token. */
export const AUTHORIZATION_HEADER = 'authorization';
/** Correlation id header echoed into logs and the error envelope. */
export const REQUEST_ID_HEADER = 'x-request-id';
/**
 * Header an admin sends to act as another member for the request. The backend
 * only honours it when the authenticated principal is an admin; everyone else
 * is rejected. Lower-cased per Node's header normalization.
 */
export const IMPERSONATE_MEMBER_HEADER = 'x-impersonate-member-id';
/**
 * Presence header: the frontend sets this to '1' only when the user genuinely
 * interacted (mouse/keyboard/touch) recently, so background polling from idle
 * tabs never marks a member as online.
 */
export const USER_ACTIVITY_HEADER = 'x-user-active';
/**
 * API key wire format: `cpsa_<prefix>_<secret>`.
 * The prefix is stored in clear for identification; the full key is shown once.
 */
export const API_KEY_BRAND = 'cpsa';
export const API_KEY_PREFIX_LENGTH = 8;
export const API_KEY_SECRET_BYTES = 24;
//# sourceMappingURL=auth.js.map